import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import ManagerLayout from "../../layouts/ManagerLayout";
import Loader from "../../components/Loader";

// Import your manager-specific tab components
import ManagerNew from "./ManagerNew";
import ManagerHMI from "./ManagerHMI";
import ManagerRTD from "./ManagerRTD";
import ManagerPNA from "./ManagerPNA";
import ManagerShipped from "./ManagerShipped";
import ManagerArchived from "./ManagerArchived";
import ManagerAll from "./ManagerAll";
import ManagerReturnAdj from "./ManagerReturnAdj";

const ManagerDash = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("new");

  // Sync tab with query params
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab") || "new";
    setActiveTab(tab);
  }, [location.search]);

  const handleTabChange = (key) => {
    navigate(`?tab=${key}`);
  };

  return (
    <ManagerLayout>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        tabBarGutter={32}
        type="line"
        tabBarStyle={{ fontSize: "16px", fontWeight: 800 }}
        items={[
          {
            key: "new",
            label: "New",
            children: <ManagerNew isActive={activeTab === "new"} />,
          },
          {
            key: "hmi",
            label: "HMI",
            children: <ManagerHMI isActive={activeTab === "hmi"} />,
          },
          {
            key: "rtd",
            label: "RTD",
            children: <ManagerRTD isActive={activeTab === "rtd"} />,
          },
          {
            key: "pna",
            label: "PNA",
            children: <ManagerPNA isActive={activeTab === "pna"} />,
          },
          {
            key: "shipped",
            label: "Shipped",
            children: <ManagerShipped isActive={activeTab === "shipped"} />,
          },
          {
            key: "ra",
            label: "Return Adjust",
            children: <ManagerReturnAdj isActive={activeTab === "ra"} />,
          },
          {
            key: "archived",
            label: "Archived",
            children: <ManagerArchived isActive={activeTab === "archived"} />,
          },
          {
            key: "all",
            label: "All",
            children: <ManagerAll isActive={activeTab === "all"} />,
          },
        ]}
      />
    </ManagerLayout>
  );
};

export default ManagerDash;
